import TestclientChart from "../../../../src/client/testclient/json/reservation.json";
import ChartTestclient from "../../../../src/client/testclient/chart/Chart.js";
import * as React from 'react';
export default {
  TestclientChart,
  ChartTestclient,
  React
};